<template>
  <div class="file-card text-center">
    <div class="icon-wrapper mx-auto mb-3"> <i :class="icon" class="fa text-shareguard icon-inner"></i> </div>
    <p class="file-title fw-bold mb-1">{{ title }}</p>
    <p class="file-meta text-muted mb-3">{{ subtitle }}</p>
    <button class="btn btn-dark btn-sm px-4 py-2" @click="gotToPath">{{ buttonText }}</button>
  </div>
</template>

<script>
export default {
  name: 'EmptyStateCard',
  props: {
    title: {
        type: String,
        default: 'Nothing to see here'
    },
    subtitle: {
        type: String,
        default: 'If this is a mistake please go back to your dashboard and try again.'
    },
    icon: {
        type: String,
        default: 'fa-exclamation'
    },
    buttonText: {
        type: String,
        default: 'To my dashboard'
    },
    path:{
        type: String,
        default: '/'
    }
  },
  methods:{
    gotToPath() {
      this.$router.push(this.path);
    }
  }
}
</script>

<style scoped>
.file-card {
  border: 2px dotted #dee2e6; /* light gray dotted border */
  border-radius: 12px;
  padding: 32px 24px;
  background-color: #fff;
  /* max-width: 400px; */
  margin: auto;
}

.icon-wrapper {
  background-color: #e9ecef; /* light background circle */
  border-radius: 50%;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-inner {
  font-size: 50px;
}

.file-title {
  font-size: 1.1rem;
}

.file-meta {
  font-size: 0.9rem;
}
</style>


